import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import { useState } from "react";
import scan from "../../assets/module-2/2-1-3-scan.png";
import LdsImage from "../../components/LdsImage";
import FigureCaption from "../../components/LdsFigureCaption";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_2_1_3 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main className="module-content">
          <section>
            <h1 className="blue text-uppercase b mt-5 mb-4">
              2.1.3 Neuroanatomy: Identifying Regions of Interest
            </h1>
            <p className="me-4">Estimated time to complete: 1 minute</p>
          </section>

          <section className="row mt-5 mb-4 justify-content-center">
            <div className="col text-center">
              <FigureCaption
                noCollapse={true}
                className="figcaption-no-border align-items-center flex-column d-flex"
                radiusSize="small"
                textContent={
                  <>
                    <p className="text-center">
                      &copy;2016. Avid Radiopharmaceuticals, Inc. All rights
                      reserved.
                    </p>
                  </>
                }
              >
                <LdsImage
                  src={scan}
                  alt="Sagittal MRI brain scan showing a side view of the brain, highlighting structures like the cerebrum, cerebellum, and brainstem with a green horizontal line across the image. Axial MRI scan of the brain with labeled regions, including the frontal lobe, anterior cingulate, lateral ventricles, temporal lobe, parietal lobe, insula, splenium of corpus callosum, precuneus, and occipital lobe. Different brain areas are outlined and labeled with distinct colors."
                  style={{ maxWidth: "964px" }}
                />
              </FigureCaption>
            </div>
          </section>

          <section>
            <p>
              Again, moving superiorly, the frontal, temporal, and occipital
              lobes continue to be visible with the precuneus coming into view,
              which is the posteromedial portion of the parietal lobe, the
              fourth of the major lobes of the cerebral cortex. Additionally,
              the insula and anterior cingulate are seen at this level.
            </p>
          </section>

          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-2/module-2-1-2", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-2/module-2-1-4", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
        </main>
      </div>
    </div>
  );
};

export default Module_2_1_3;
